import React from 'react';

const Footer = () => {
    return (
        <footer style={{backgroundColor:'black',color:'white',padding:'10px 0'}}>
            Made by Incognito
        </footer>
    )
}

export default Footer;